import VDialog, { XDialog, ThemeVDialog } from './src/main.js'

VDialog.install = function (Vue) {
  Vue.prototype.$dialog = VDialog
  Vue.prototype.$themeDialog = ThemeVDialog
}

export { XDialog }
export default VDialog
